import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({ providedIn: 'root' })
export class StorageService {

    // region Fields

    private storage: Storage;

    static readonly IMPERSONATION_MODE_KEY = 'NDRU_IMPERSONATION_MODE';
    static readonly IMPERSONATION_NAVIGATE_KEY = 'NDRU_IMPERSONATION_NAVIGATE';
    static readonly AUTH_TOKEN_KEY = 'NDRU_AUTH_TOKEN';

    private readonly impersonationModeKey = StorageService.IMPERSONATION_MODE_KEY;

    private get activeStorage(): globalThis.Storage {
        return sessionStorage.getItem(this.impersonationModeKey) ? sessionStorage : localStorage;
    }

    private readonly authTokenKey = StorageService.AUTH_TOKEN_KEY;

    getAuthToken(): string {
        return this.activeStorage.getItem(this.authTokenKey);
    }

    setAuthToken(value: string): void {
        this.activeStorage.setItem(this.authTokenKey, value);
    }

    clearAuthToken(): void {
        this.activeStorage.removeItem(this.authTokenKey);
    }

    private readonly refreshTokenKey: string = 'NDRU_REFRESH_TOKEN';

    getRefreshToken(): string {
        return this.activeStorage.getItem(this.refreshTokenKey);
    }

    setRefreshToken(value: string): void {
        this.activeStorage.setItem(this.refreshTokenKey, value);
    }

    clearRefreshToken(): void {
        this.activeStorage.removeItem(this.refreshTokenKey);
    }

    clearImpersonationSession(): void {
        sessionStorage.removeItem(StorageService.IMPERSONATION_MODE_KEY);
        sessionStorage.removeItem(StorageService.AUTH_TOKEN_KEY);
    }

    private readonly lastUserNameKey: string = 'NDRU_LAST_USER_NAME';

    getLastUserName(): string | null {
        return localStorage.getItem(this.lastUserNameKey);
    }

    setLastUserName(value: string): void {
        if (sessionStorage.getItem(this.impersonationModeKey)) return;
        localStorage.setItem(this.lastUserNameKey, value);
    }

    private readonly languageKey: string = 'NDRU_LANGUAGE';

    getLanguage(): string {
        return localStorage.getItem(this.languageKey);
    }

    setLanguage(value: string): void {
        localStorage.setItem(this.languageKey, value);
    }

    clearLanguage(): void {
        localStorage.removeItem(this.languageKey);
    }


    private readonly warehouseSettingKey: string = 'NDRU_WAREHOUSE_SETTING';

    getWarehouseSetting(): string {
        return localStorage.getItem(this.warehouseSettingKey);
    }

    setWarehouseSetting(value: string): void {
        localStorage.setItem(this.warehouseSettingKey, value);
    }

    // endregion

    // region Initialization

    constructor(storage: Storage) {
        this.init(storage);
    }

    private async init(storage: Storage) {
        this.storage = await storage.create();
    }

    // endregion

    // region Methods

    async set(key: string, value: any) {
        await this.storage?.set(key, value);
    }

    get(key: string): Promise<any> {
        return this.storage?.get(key);
    }

    async remove(key: string) {
        await this.storage?.remove(key);
    }

    // endregion
}
